const createWorkout = () => {};

export default createWorkout;
